<template>
    <div>
        <embed :src="pdfUrl" style="width: 100%; height: 600px;"/>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            pdfUrl: ''
        }
    },
    created() {
    },
    mounted() {
        this.loadPdfUrl();
    },
    methods: {
        async loadPdfUrl() {
            var url = "patent/find/pdf/url/" + this.data.detail.pid;
            const { data: res } = await this.$http.get(url);
            if (res.code == 0) {
                this.pdfUrl = res.data;
            } else {
                this.$message.error(res.msg);
            }
        },
    }
}
</script>

<style>
</style>